define(['marionette', '../avatar/index'], function (Marionette, AvatarView) {
  return Marionette.CollectionView.extend({
    template: false,
    childView: AvatarView,
    childViewOptions: function () {
      return {
        showRank: this.options.showRank,
        size: this.options.size
      }
    }
  })
})
